const Layout1Settings = {
  leftSidebar: {
    show: true,
    mode: "full", // full, close, compact, mobile,
    theme: "slateDark1",
    // bgOpacity: .96, // 0 ~ 1
    bgImgURL: "/assets/images/sidebar/sidebar-bg-dark.jpg",
  },
  topbar: {
    show: true,
    fixed: true,
    theme: "purpleDark1",
  },
};

export default Layout1Settings;
